import { render, staticRenderFns } from "./SelectSpaceArrangment.vue?vue&type=template&id=4c5c10d2&scoped=true"
import script from "./SelectSpaceArrangment.vue?vue&type=script&lang=js"
export * from "./SelectSpaceArrangment.vue?vue&type=script&lang=js"
import style0 from "./SelectSpaceArrangment.vue?vue&type=style&index=0&id=4c5c10d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c10d2",
  null
  
)

export default component.exports